// removed by extract-text-webpack-plugin
module.exports = {"sso-login-seperator":"sso-login-seperator","ssoLoginSeperator":"sso-login-seperator"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/externalSsoLogins/style.scss
// module id = 601
// module chunks = 0